import { QueryKey, UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import fetchBankStatementsAvailabilityList from './useBankStatementsAvailabilityList.request';
import { BankStatementsAvailabilityListResponse } from './useBankStatementsAvailabilityList.interface';

/**
 * Creates a query key for the bank statements availability list
 * @returns QueryKey for the bank statements availability list
 */
export const createUseBankStatementsAvailabilityListKey = (): QueryKey => {
    return ['bookkeeping', 'bankStatementsAvailabilityList'];
};

/**
 * Hook to fetch a list of bank statement availability
 * @param params - Optional parameters for the request
 * @param options - Optional react-query options
 * @returns Query result with the bank statements availability list
 */
const useBankStatementsAvailabilityList = <T = BankStatementsAvailabilityListResponse>(
    options?: UseQueryOptions<BankStatementsAvailabilityListResponse, AxiosError, T>
) => {
    return useQuery({
        queryKey: createUseBankStatementsAvailabilityListKey(),
        queryFn: () => fetchBankStatementsAvailabilityList(),
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnMount: true, // Changed to true to ensure refetch on mount
        staleTime: 0, // Changed to 0 to ensure data is always considered stale
        ...options,
    });
};

export default useBankStatementsAvailabilityList;
